export default __webpack_public_path__ + "static/media/eth.77638db5.png";